import { type IApiResponseError } from "../interfaces/api-response.interface";

export function extractErrorDescription(error: IApiResponseError): string {
  if (error?.message == null) {
    return "";
  }
  return Array.isArray(error.message) ? error.message.join(" ") : error.message;
}
